import { RpiTable } from "../../rpi-core/table/RpiTable";
import { GraphQL, GraphQLPagedQueryData } from "@rpi/openapi-api";
import { useNavigateRoute } from "../../hooks/useNavigateRoute";
import { Menu } from "@mantine/core";
import { IconV3 } from "@rpi/openapi-core";
import { orderColumnsV2 } from "../../configuration/columns/ordersV2.column";
import { createRpaTableMenuColumn, RpaTableMenu } from "../../components/RpaTableMenu";
import { RpiTableV2Container, RpiTableFooter } from "../../components/RpiTableV2Container";
import React from "react";
import { RpiTableSortByProviderProps } from "../../rpi-core/table/modules/RpiTableSortBy";

type OrdersType = GraphQLPagedQueryData<GraphQL.OrdersQuery>;

export interface OrdersTableV2Props {
  orders?: OrdersType[];
  isLoading: boolean;
  error?: unknown;
  withSortBy?: Omit<RpiTableSortByProviderProps, "children"> | undefined;
}

export function OrdersTableV2({
  orders,
  isLoading,
  error,
  withSortBy,
  children,
}: React.PropsWithChildren<OrdersTableV2Props>) {
  return (
    <RpiTableV2Container>
      <RpiTable
        variant="normalV2"
        withSortBy={withSortBy}
        emptyMessage={"No orders found."}
        isLoading={isLoading}
        error={error}
        perPage={orders?.length}
        data={orders}
        columns={orderColumnsV2}
        additionalColumns={[
          createRpaTableMenuColumn<OrdersType>((row) => {
            const customerPublicId = row.customer?.publicId;
            const customerOrderId = row.customerOrderId;
            if (!customerPublicId || !customerOrderId) {
              return null;
            }
            return <OrdersTableActionMenu customerPublicId={customerPublicId} customerOrderId={customerOrderId} />;
          }),
        ]}
      />
      {children}
    </RpiTableV2Container>
  );
}

export function OrdersTableFooter({ children }: React.PropsWithChildren) {
  return <RpiTableFooter>{children}</RpiTableFooter>;
}

type OrdersActionMenuProps = {
  customerPublicId: string;
  customerOrderId: string;
};
function OrdersTableActionMenu({ customerPublicId, customerOrderId }: OrdersActionMenuProps) {
  const navigateRoute = useNavigateRoute();
  return (
    <RpaTableMenu>
      <Menu.Item
        icon={<IconV3 icon="description" size={20} />}
        onClick={() => navigateRoute(["order", { customerPublicId, customerOrderId }])}
      >
        View Details
      </Menu.Item>
    </RpaTableMenu>
  );
}
